import { Pipe, PipeTransform } from '@angular/core';
import { BossResources } from 'se-resource-types';
import { environment } from '../../../environments/environment';

@Pipe({
  standalone: false,
  name: 'legacyReportLink',
})
export class LegacyReportLinkPipe implements PipeTransform {
  transform(currentOrg?: BossResources.Organization): string | undefined {
    return currentOrg && `${environment.urls.hq}/org/${currentOrg.id}/reports/payouts`;
  }
}
